import Image from 'chat-ui/src/components/Image/Image';

interface CustomLogoProps {
  logoUrl: string;
  className?: string;
}

export default function CustomLogo({ logoUrl, className }: CustomLogoProps) {
  return <Image src={logoUrl} alt="logo" className={`${className} object-contain`} />;
}
